import React, { useLayoutEffect, useRef, useState } from "react";
import uuid from "react-uuid";

import styles from './ReleaseNotes.module.css'

type TReleaseNotes = {
  releaseNotes: string[],
  expandHeight?: number,
  expanded?: boolean,
  twoColumns?: boolean,
}

const ReleaseNotes: React.FC<TReleaseNotes> = ({ releaseNotes, expandHeight, expanded, twoColumns }) => {
  const [isOpened, setIsOpened] = useState(false);
  const [compareHeight, setCompareHeight] = useState(false);

  const ulRefComponent = useRef<HTMLUListElement>(null);
  const wrapperRefComponent = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (expanded) return;

    const ulHeight = ulRefComponent?.current?.getBoundingClientRect()?.height
    const wrapperHeight = wrapperRefComponent?.current?.getBoundingClientRect()?.height

    if (ulHeight && wrapperHeight) {
      setCompareHeight(ulHeight + 26 > wrapperHeight);
    }
  }, [expanded]);
  return (
    (releaseNotes.length)
      ?
      <div
        ref={wrapperRefComponent}
        className={`${styles.notes} ${(isOpened || expanded) && styles.open}`}>
        <h4 className={styles.heading}>Release Notes</h4>
        <ul
          ref={ulRefComponent}
          className={`${styles.list} ${twoColumns ? styles.twoCols : ''}`}>
          {
            releaseNotes.map(((text) => <li key={uuid()}>{text}</li>))
          }
        </ul>
        {
          !expanded && compareHeight && !isOpened &&
          <div
            onClick={() => setIsOpened(true)}
            className={`${styles.more}`}>
            Show more
          </div>
        }
      </div>
      :
      <></>
  );
};

export default ReleaseNotes;